function addToCart() {
    const productSubmitButtons = document.querySelectorAll('[data-product-submit]');
    const quickViewModal = document.querySelector('[data-modal="quickview-modal"]');
    const collectionProductsContainer = document.querySelector('[data-collection-products-container]');

    if (collectionProductsContainer) {
        collectionProductsContainer.addEventListener('click', (event) => {
            if (!event.target.hasAttribute('data-product-submit')) {
                return;
            }

            event.preventDefault();

            productSubmitEvent(event.target);
        });
    }

    if (quickViewModal) {
        quickViewModal.addEventListener('click', (event) => {
            if (!event.target.hasAttribute('data-product-submit')) {
                return;
            }

            event.preventDefault();

            productSubmitEvent(event.target);
        });
    }

    if (!productSubmitButtons) {
        return;
    }

    productSubmitButtons.forEach((productSubmitButton) => {
        productSubmitButton.addEventListener('click', (event) => {
            event.preventDefault();

            productSubmitEvent(productSubmitButton);
        });
    });

    function productSubmitEvent(button) {
        const productForm = button.closest('[data-product-form]');
        const quantityInput = productForm.querySelector('[data-quantity-input]');
        const lineItemVariantId = parseInt(productForm.querySelector('[data-product-select]').value,
            10);
        const lineItemQuantity = quantityInput ? quantityInput.value : 1;
        const lineItemProperties = {};
        const formInputs = productForm.querySelectorAll('input, select, textarea');
        const formSubscriptionSelectorWrapper = document.querySelector('[data-product-subscription-selector-wrapper]');
        const formSubscriptionSelector = productForm.querySelector('[data-product-subscription-selector]');

        if (formInputs.length) {
            formInputs.forEach((formInput) => {
                const nameAttr = formInput.getAttribute('name');
                const typeAttr = formInput.getAttribute('type');

                if (nameAttr && nameAttr.indexOf('properties') >= 0) {
                    const propertyName = nameAttr.split('[')[1].replace(']', '');
                    let propertyValue = '';

                    if (
                        typeAttr &&
                        (typeAttr === 'radio' || typeAttr === 'checkbox')
                    ) {
                        if (formInput.checked === true) {
                            propertyValue = formInput.value;
                        }
                    } else {
                        propertyValue = formInput.value;
                    }

                    if (propertyValue !== '') {
                        lineItemProperties[propertyName] = propertyValue;
                    }
                }
            });
        }

        const lineItem = {
            id: lineItemVariantId,
            quantity: lineItemQuantity,
            properties: lineItemProperties
        };

        if (
            formSubscriptionSelectorWrapper &&
            !formSubscriptionSelectorWrapper.classList.contains('hide') &&
            formSubscriptionSelector &&
            formSubscriptionSelector.value
        ) {
            lineItem.selling_plan = parseInt(formSubscriptionSelector.value, 10);
        }

        // eslint-disable-next-line no-undef
        document.dispatchEvent(new CustomEvent('minicart:product:add', {
                detail: {
                    items: [lineItem],
                    callback() {
                        const quickviewModalClose = document.querySelector('[data-modal="quickview-modal"] [data-modal-close]');
                        if (!quickviewModalClose) {
                            return;
                        }

                        quickviewModalClose.click();
                    }
                }
            }));
    }
}

function updateLineItem(lineItemKey, lineItemQuantity) {
    const lineItem = {
        id: lineItemKey,
        quantity: lineItemQuantity
    };

    // eslint-disable-next-line no-undef
    document.dispatchEvent(new CustomEvent('minicart:products:change', {
            detail: {
                item: lineItem
            }
        }));
}

function removeLineItem() {
    document.addEventListener('click', (event) => {
        if (!event.target.hasAttribute('data-line-item-remove')) {
            return;
        }

        event.preventDefault();

        const lineItemKey = event.target.getAttribute('data-line-item-key');
        updateLineItem(lineItemKey, 0);
    });
}

function removeBoxItem() {
    document.addEventListener('click', (event) => {
        if (!event.target.hasAttribute('data-box-item-remove')) {
            return;
        }

        const lineItemKeys = event.target
            .getAttribute('data-box-item-remove')
            .split(',');
        const itemsToRemove = {
            updates: {}
        };

        lineItemKeys.forEach((lineItemKey) => {
            itemsToRemove.updates[lineItemKey] = 0;
        });

        // eslint-disable-next-line no-undef
        document.dispatchEvent(new CustomEvent('minicart:product:update', {
                detail: {
                    updates: itemsToRemove.updates
                }
            }));
    });
}

function quantitySelector() {
    document.addEventListener('click', (event) => {
        let { target } = event;
        if (!target) {
            return;
        }

        if (!target.hasAttribute('data-quantity-adjust')) {
            target = target.closest('[data-quantity-adjust]');
        }

        if (!target) {
            return;
        }

        if (!target.hasAttribute('data-quantity-adjust')) {
            return;
        }

        const quantitySelector = target.closest('[data-quantity-selector]');
        if (!quantitySelector) {
            return;
        }

        const quantityInput = quantitySelector.querySelector('[data-quantity-input]');
        if (!quantityInput) {
            return;
        }

        const lineItemKey = quantityInput.getAttribute('data-line-item-key');
        const lineItemMaxQuantity = parseFloat(quantityInput.max ? quantityInput.max : Infinity);
        let lineItemQuantity = parseFloat(quantityInput.value);

        if (event.target.hasAttribute('data-quantity-minus')) {
            if (quantityInput.value > 1) {
                lineItemQuantity -= 1;
            } else if (
                !quantitySelector.hasAttribute('data-product-quantity-selector')
            ) {
                lineItemQuantity = 0;
            } else {
                lineItemQuantity = 1;
            }

            if (
                quantitySelector.hasAttribute('data-product-quantity-selector')
            ) {
                quantityInput.value = lineItemQuantity;
            }
        } else if (event.target.hasAttribute('data-quantity-plus')) {
            if (quantityInput.value <= lineItemMaxQuantity) {
                lineItemQuantity += 1;

                if (
                    quantitySelector.hasAttribute('data-product-quantity-selector')
                ) {
                    quantityInput.value = lineItemQuantity;
                }
            }
        }

        if (!quantitySelector.hasAttribute('data-product-quantity-selector')) {
            updateLineItem(lineItemKey, lineItemQuantity);
        } else {
            quantityInput.dispatchEvent(new Event('change'));
        }
    });

    document.addEventListener('change', (event) => {
        if (!event.target.hasAttribute('data-quantity-input')) {
            return;
        }

        const quantitySelector = event.target.closest('[data-quantity-selector]');
        const lineItemKey = event.target.getAttribute('data-line-item-key');
        const lineItemMaxQuantity = parseFloat(event.target.max);
        let lineItemQuantity = parseFloat(event.target.value);

        if (lineItemQuantity > lineItemMaxQuantity) {
            lineItemQuantity = lineItemMaxQuantity;
        } else if (lineItemQuantity < 1) {
            lineItemQuantity = 0;
        }

        if (!quantitySelector.hasAttribute('data-product-quantity-selector')) {
            updateLineItem(lineItemKey, lineItemQuantity);
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    addToCart();
    removeLineItem();
    quantitySelector();
    removeBoxItem();
});
